import { Button, Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import ErrorMessage from '../../../Common/ErrorMessage';
import ContentCopy from '@mui/icons-material/ContentCopy';
import FileCopy from '@mui/icons-material/FileCopy';
import { REFERRAL_URL } from '../../../utils/urls';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ReferEarnImg from '../../../utils/assests/refer-icon.png';
import { WhatsappShareButton, WhatsappIcon } from 'react-share';
import Card from '@mui/material/Card';
const ReferEarnForm = (props: any) => {
  const ICON_DEFAULTS = {
    round: true,
    size: 60,
  };
  const {
    referEarnData,
    referEarnError,
    onClickCopy,
    referLink,
    handleReferNow,
    referUrl,
    user,
    referalCode,
    onClickCopyReferaCode,
    referLinkCode
  } = props;
  return (
    <>
      <Box className='circleImage'>
        <Typography variant='h1'>
          Sharing is <br /> rewarding
        </Typography>
        <img src={ReferEarnImg} alt='' />
      </Box>
      <Box className='investSuccess'>
        <Typography variant='h1'>earn up to ₹10,000</Typography>
        <Typography>
          Share this link with your <br /> friends & family
        </Typography>
      </Box>
      <Box className='shareLink-referalCode'>
        <Box
          className='shareLinkBox'
          display='flex'
          alignItems='center'
          justifyContent='space-between'
        >
          <Box>
            <Typography>{referalCode}</Typography>
          </Box>
          <Button
            variant='contained'
            className={referLinkCode && 'colorPink text-white'}
            onClick={onClickCopyReferaCode}
            // endIcon={<ContentCopyIcon />}
          >
            Copy code
          </Button>
        </Box>
      </Box>

      <Box className='shareLink'>
        <Box
          className='shareLinkBox'
          display='flex'
          alignItems='center'
          justifyContent='space-between'
        >
          <Box>
            <Typography>{referUrl}</Typography>
          </Box>
          <Button
            variant='contained'
            className={referLink && 'colorPink text-white'}
            onClick={onClickCopy}
            // endIcon={<ContentCopyIcon />}
          >
            Copy link
          </Button>
        </Box>
      </Box>
      <Box className='socialShareOption'>
        <Typography variant='h2'>
          You earn 10% on the <br /> interest your friend earns!
        </Typography>
        {referEarnError && <ErrorMessage text={referEarnError} />}

        <Card>
          <Typography>Share by </Typography>
          <WhatsappShareButton
            url={`Hi ${
              user && user
            } invites you to StashEarn! Start earning high returns up to *9.25%* with your friend by joining the new age peer to peer investment platform.${'\n'}${'\n'}Click ${referUrl} to *Get.Set.Earn* -Stashfin`}
          >
            <WhatsappIcon {...ICON_DEFAULTS} onClick={handleReferNow} />
          </WhatsappShareButton>
        </Card>
      </Box>
    </>
  );
};

export default ReferEarnForm;
